<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-04-18 15:31:56
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveTypePropertyGroup\LeaveTypePropertyGroup.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_leaveTypePropertyGroup_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-leave-type-policy')"
    @new="toNew"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
    :exportBtn="hasBtn('export-admin-leave-type-policy')"
    :importBtn="hasBtn('import-admin-leave-type-policy')"
    :import-options="{
      api: '/leave-type-property-group/import/',
      templateUrl:
        'https://assets.essencehr.io/web/ess-business/assets/leave-type-group-import-template.xlsx',
      success: (result) => {
        getList(null, 1, $tableSetting.perPageSize, null);
      },
    }"
    @export="onExport"
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :filter-page-data="filterPageData"
        :totalCount="totalCount"
        :height="$vuetify.breakpoint.height - 275 - 48"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.leave_type_property_group_name)"
          >
            {{ $getCommonLangValue(item.leave_type_property_group_name) }}
          </div>
          <!-- <div class="text--secondary table-subtitle">
            {{
              $getCommonLangValue(item.leave_type_property_group_description)
            }}
          </div> -->
        </template>
        <template v-slot:item.code="{ item }">
          <div class="text--primary table-title">
            {{ item.leave_type_property_group_code }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-leave-type-policy')"
            :editBtn="hasBtn('edit-admin-leave-type-policy')"
            :viewBtn="hasBtn('view-admin-leave-type-policy')"
            :title="$t('label_essweb_leaveTypePropertyGroup_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "LeaveTypePG",
  computed: {},
  data() {
    return {
      showSelect: false,
      selected: [],
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_leaveTypePropertyGroup_list_leaveTypePropertyGroupNameLasbel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveTypePropertyGroup_form_codeLabel",
          value: "code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      filterPageData: null,
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label:
            "label_essweb_leaveTypePropertyGroup_list_leaveTypePropertyGroupNameLasbel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "string",
          sequence: 1,
          name: "code",
          position: "right",
          label: "label_essweb_leaveTypePropertyGroup_form_codeLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    onExport() {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "code") {
          data["leave_type_property_group_code_like"] = item.value;
        }
        if (item["name"] == "name") {
          data["leave_type_property_group_name"] = item.value;
        }
      });
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type_property_group",
        url: "/leave-type-property-group/export/",
        data: data,
        type: "export",
        export_title: this.$t("label_essweb_leaveTypePropertyGroup_list_title"),
      });
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "code") {
          data["leave_type_property_group_code_like"] = item.value;
        }
        if (item["name"] == "name") {
          data["leave_type_property_group_name"] = item.value;
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type_property_group",
        url: "/leave-type-property-group/get-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/leave-type-policy/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/leave-type-policy/edit/"
          : "/admin/leave-type-policy/detail/") + uuid
      );
    },
    toDelete: function (uuid) {
      const that = this;
      this.showDelete = false;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type_property_group",
        url: "/leave-type-property-group/delete/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveTypePropertyGroup_list_deleteLeaveTypePropertyGroupSuccessLasbel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
